import * as React from 'react';
import { observer } from 'mobx-react';
import { FormField } from './form-field';
import { Textbox } from '../primitives/textbox';
import { FieldValidationMessage } from './form-control/form-control-validation-error';
import { TextMaskInput } from './text-mask-input';
import { FormControlLabel } from '../primitives/label';
import { FocusOnMount } from './focus-on-mount-hoc';
import { panelContentTransitionDuration } from './panel-content-transition';
import { UiConfigurationContext } from '../providers/uiconfiguration';

export interface IRoutingNumberInputProps {
	value: FormField<string>;
	formControlId: string;
	acceptanceTestTargetId: string;
	onFocus?: () => void;
	onBlur?: () => void;
	focusOnMount?: boolean;
}

const mask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];

@observer
export class RoutingNumberInput extends React.Component<IRoutingNumberInputProps, {}> {
	static contextType = UiConfigurationContext
	context!: React.ContextType<typeof UiConfigurationContext>;

	render() {
		const { value: { value, updateValue, validationError, hasValidationError }, formControlId, onFocus, onBlur, focusOnMount, acceptanceTestTargetId } = this.props;
		const additionalClassNames = hasValidationError ? 'form-control-invalid' : '';
		const maskedInput = (
			<TextMaskInput mask={mask}>
				<Textbox
					value={value}
					formControlId={formControlId}
					onChange={updateValue}
					acceptanceTestTargetId={acceptanceTestTargetId}
					numericKeyboard
					onFocus={onFocus}
					onBlur={onBlur}
					disableTranslation={this.context.SkipGivePage} // Without placeholder text, there's no need to translate
					dataFieldInvalid={hasValidationError}
					additionalClassNames={additionalClassNames}
				/>
			</TextMaskInput>
		);

		return (
			<div className="form-control-container">
				<FormControlLabel formControlId={formControlId}>Routing number</FormControlLabel>
					{focusOnMount ? (
						<FocusOnMount delay={panelContentTransitionDuration}>
							{maskedInput}
						</FocusOnMount>
					) : maskedInput}
				<FieldValidationMessage errorMessage={validationError} />
			</div>
		);
	}
}
